import React from "react";
import ImageUpload from "../image-upload/ImageUpload";
import { useOverlayPopupOpen } from "../../hooks/use-overlay-popup-open";
import "../vehicle-upload-card/vehicle-upload-card.scss";

interface PolicyVehicleUploadProps {
  visible: boolean;
  onImagesUploaded: (files: File[]) => void;
  uploadedCount: number;
}

export const PolicyVehicleUpload: React.FC<PolicyVehicleUploadProps> = ({
  visible,
  onImagesUploaded,
  uploadedCount,
}) => {
  useOverlayPopupOpen(visible);
  if (!visible) return null;

  return (
    <div className="vehicle-upload-overlay">
      <div className="card-width vehicle-upload-card">
        <h3 className="vehicle-upload-title">صور المركبة</h3>
        <p className="vehicle-upload-hint">
          ارفع 5 صور للسيارة: الشاسيه، الأمامية، اليمنى، الخلفية، اليسرى
        </p>
        <ImageUpload
          onImagesUploaded={onImagesUploaded}
          maxImages={5}
          title="صور المركبة"
        />
        {uploadedCount > 0 && (
          <div className="vehicle-upload-progress">
            تم رفع {uploadedCount} من 5 صور
          </div>
        )}
      </div>
    </div>
  );
};

